// extracted by mini-css-extract-plugin
export default {"expandedTabLv2__wrapper":"ExpandedTabLv2_expandedTabLv2__wrapper__qtUXq"};